import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "coremodules"
    }}>{`CoreModules`}</h1>
    <h2 {...{
      "id": "namespaces"
    }}>{`Namespaces`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/media/photoshopaction/"
        }}>{`photoshopAction`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/media/photoshopcore/"
        }}>{`photoshopCore`}</a></li>
    </ul>
    <h2 {...{
      "id": "interfaces"
    }}>{`Interfaces`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/actiondescriptor/"
        }}>{`ActionDescriptor`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/batchplaycommandoptions/"
        }}>{`BatchPlayCommandOptions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/cpuinfo/"
        }}>{`CPUInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/executeasmodaloptions/"
        }}>{`ExecuteAsModalOptions`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/executioncontext/"
        }}>{`ExecutionContext`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/gpuinfo/"
        }}>{`GPUInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/historystateinfo/"
        }}>{`HistoryStateInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/opencldeviceinfo/"
        }}>{`OpenCLDeviceInfo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/photoshop/uxp/ps_reference/interfaces/opengldeviceinfo/"
        }}>{`OpenGLDeviceInfo`}</a></li>
    </ul>
    <h2 {...{
      "id": "type-aliases"
    }}>{`Type aliases`}</h2>
    <h3 {...{
      "id": "cpuvendorkind"
    }}>{`CPUVendorKind`}</h3>
    <p>{`Ƭ `}<strong parentName="p">{`CPUVendorKind`}</strong>{`: `}<inlineCode parentName="p">{`"Intel"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"AMD"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"ARM"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="p">{`"Unknown"`}</inlineCode></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      